
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class SieveSizeMappingGrid extends Serenity.EntityGrid<SieveSizeMappingRow, any> {
        protected getColumnsKey() { return 'OMS.SieveSizeMapping'; }
        protected getDialogType() { return SieveSizeMappingDialog; }
        protected getIdProperty() { return SieveSizeMappingRow.idProperty; }
        protected getInsertPermission() { return SieveSizeMappingRow.insertPermission; }
        protected getLocalTextPrefix() { return SieveSizeMappingRow.localTextPrefix; }
        protected getService() { return SieveSizeMappingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}